import React, { useState, useRef, useEffect } from "react";

import { FaMinus, FaPlus } from "react-icons/fa";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import axios from "axios";

const CustomerFaqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [allfaqs, setAllfaqs] = useState([]);
  const handleToggle = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  const fetchFaqs = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}admin/getFaqs`
      );
      setAllfaqs(response?.data);
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };
  useEffect(() => {
    fetchFaqs();
  }, []);
  const filterData = allfaqs.filter((item) =>{
    return item.isCustomerFAQ === true
  })
  return (
    <>
      <section>
        <div className="container">
          <h1>Frequently Asked Questions</h1>
          <div className="mx-auto bg-white rounded-lg p-[20px]">
            {filterData.length > 0 ? (
              filterData.map((faq, index) => (
                <FAQAccordionItem
                  key={faq._id}
                  active={activeIndex === index}
                  handleToggle={() => handleToggle(index)}
                  faq={faq}
                />
              ))
            ) : (
              <p className="text-center text-gray-500">No FAQs available.</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};
const FAQAccordionItem = ({ handleToggle, active, faq }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");
  useEffect(() => {
    if (contentRef.current) {
      setHeight(active ? `${contentRef.current.scrollHeight}px` : "0px");
    }
  }, [active]);
  return (
    <div className="mb-[20px] shadow-[0px_3px_15px_0px_rgba(0,0,0,0.1)] overflow-hidden rounded-[10px]">
      <div
        className={`p-[20px] flex justify-between items-center cursor-pointer ${
          active ? "bg-[#f48533] text-white" : ""
        }`}
        onClick={handleToggle}
      >
        <h5 className="mb-0 lg:text-[20px] text-[18px]">{faq.questions}</h5>
        <span>{active ? <FaMinus /> : <FaPlus />}</span>
      </div>
      <div
        ref={contentRef}
        className="overflow-hidden transition-all duration-300"
        style={{ maxHeight: height }}
      >
        <div className="p-[20px]">
          <p className="mb-0">{faq.answers}</p>
          {faq.answerList && (
            <ul className="mt-[15px]">
              {faq.answerList.map((item, i) => (
                <li key={i} className="mb-[8px] text-[16px] relative pl-[25px]">
                  <IoCheckmarkDoneSharp className="text-[17px] inline-block text-[#f48533] absolute left-0 top-[5px]" />
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};
export default CustomerFaqs;
